import React from 'react'
import Snackbar from 'material-ui-effco/Snackbar'

const MuiSnackbar = props => {
  const {
    open = false,
    message = 'test',
    label = '',
    timeout = 2500,
    clear
    // action
  } = props
  return (
    <Snackbar
      open={open}
      message={message}
      action={label}
      autoHideDuration={timeout}
      onRequestClose={clear}
    // onActionTouchTap={action}
    />
  )
}

export default MuiSnackbar



// WEBPACK FOOTER //
// ./src/core/components/Snackbar.js